import { render, staticRenderFns } from "./error-monitor.view.vue?vue&type=template&id=07908f26&scoped=true&"
import script from "./error-monitor.view.vue?vue&type=script&lang=ts&"
export * from "./error-monitor.view.vue?vue&type=script&lang=ts&"
import style0 from "./error-monitor.view.vue?vue&type=style&index=0&id=07908f26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07908f26",
  null
  
)

export default component.exports